import api from "./api";

// Fetch all vehicles
export const fetchAllVehicles = async () => {
  try {
    const response = await api.get('/vehicle-management/vehicles');
    if (response.status === 200) {
      return response.data;
    } else {
      console.warn("Unexpected Response:", response);
      return { error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error fetching vehicles:", error.message || error);
    return { error: error.response?.data?.detail || error.message || "Failed to fetch vehicles" };
  }
};


// Update vehicle status
export const updateVehicleStatus = async (vehicleId, status, statusReason = null) => {
  try {
    const payload = {
      status,
      ...(statusReason && { status_reason: statusReason }), // include only if provided
    };

    const response = await api.put(`/vehicle-management/vehicles/${vehicleId}/status`, payload);

    if (response.status === 200) {
      return { success: true, data: response.data };
    } else {
      console.warn("Unexpected Response:", response);
      return { success: false, error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error updating vehicle status:", error.message || error);
    return {
      success: false,
      error: error.response?.data?.detail || error.message || "Failed to update vehicle status",
    };
  }
};

